import { Link } from 'react-router-dom';

export function NotFoundRoute() {
  return (
    <section className="panel">
      <h2>Not found</h2>
      <p className="empty">That page does not exist.</p>
      <Link to="/">Back to home</Link>
    </section>
  );
}
